module.exports = __webpack_public_path__ + "static/media/archer_drone_selected.2a2be763.svg";